import axios from "axios";

import { apiDomain } from "../../store/constants";

const USPExtend = {
  index(params) {
    return axios({
      url: apiDomain + `api/pending-form`,
      method: "GET",
      params: params,
    }).catch((e) => {
      return e.response;
    });
  },

  show(id) {
    return axios({
      url: apiDomain + `api/pending-form/${id}`,
      method: "GET",
    }).catch((e) => {
      return e.response;
    });
  },

  create(form_id, form_type) {
    return axios({
      url: apiDomain + `api/pending-form/create?form_id=${form_id}&form_type=${form_type}`,
      method: "GET",
    }).catch((e) => {
      return e.response;
    });
  },

  store(data) {
    // data.files = JSON.stringify(data.files);
    return axios({
      url: apiDomain + `api/pending-form`,
      method: "POST",
      data: data,
    }).catch((e) => {
      return e.response;
    });
  },

  edit(id) {
    return axios({
      url: apiDomain + `api/pending-form/${id}/edit`,
      method: "GET",
    }).catch((e) => {
      return e.response;
    });
  },

  update(payload) {
    return axios({
      url: apiDomain + `api/pending-form/${payload.id}`,
      method: "PUT",
      data: payload.data,
    }).catch((e) => {
      return e.response;
    });
  },

  updatePendingFormStatus (data) {
    return axios({
        url: apiDomain + `api/pending-form/update-status/` + data.id,
        method: 'PUT',
        data: data.payload
    }).catch((e) => {
        return e.response
    })
},

  delete(id) {
    return axios({
      url: apiDomain + `api/pending-form/${id}`,
      method: "DELETE",
    }).catch((e) => {
      return e.response;
    });
  },
};

export default USPExtend;
